import { createContext, useContext } from 'react'
import type { TenantConfig } from '@/lib/tenant'
import { getTenant } from '@/lib/tenant'

const TenantContext = createContext<TenantConfig>(getTenant())

export function TenantProvider({ children }: { children: React.ReactNode }) {
  return (
    <TenantContext.Provider value={getTenant()}>
      {children}
    </TenantContext.Provider>
  )
}

export function useTenant() {
  return useContext(TenantContext)
}
